@if (formGroup) {
  <form
    id="dk-input"
    class="form-group text-right"
    [class.my-3]="has_my3"
    [class.mb-3]="has_mb3"
    [formGroup]="formGroup">
    <dk-label
      [label]="label"
      [labelDescription]="labelDescription"
      [isRequired]="required"
      [disabled]="disabled || control?.disabled" />

    <div class="input-group">
      @if (!mask) {
        @switch (type) {
          @case ('number') {
            <p-inputNumber
              mode="decimal"
              [useGrouping]="separateNumbers"
              [formControlName]="controlName"
              [class.is-valid]="!control?.invalid && control?.touched"
              [class.is-invalid]="control?.invalid && control?.touched"
              [required]="required"
              [placeholder]="placeholder | translate"
              [min]="min"
              [max]="max"
              [minFractionDigits]="minDecimalDigits"
              [maxFractionDigits]="maxDecimalDigits"
              [disabled]="disabled"
              [autocomplete]="autocomplete"
              (onChange)="onChange.emit($event)"
              [id]="controlName" />
          }
          @case ('password') {
            <p-password
              [formControlName]="controlName"
              [toggleMask]="toggleMask"
              [feedback]="feedback"
              [autocomplete]="autocomplete"
              [placeholder]="placeholder | translate"
              [class.is-valid]="!control?.invalid && control?.touched"
              [class.is-invalid]="control?.invalid && control?.touched"
              (change)="onChange.emit($event)"
              [id]="controlName" />
          }
          @default {
            <input
              #input
              class="p-inputwrapper"
              pInputText
              [type]="type"
              [formControlName]="controlName"
              [class.is-valid]="!control?.invalid && control?.touched"
              [class.is-invalid]="control?.invalid && control?.touched"
              [required]="required"
              [placeholder]="placeholder | translate"
              [minlength]="minlength"
              [maxlength]="maxlength"
              [disabled]="disabled"
              [autocomplete]="autocomplete"
              [pattern]="pattern"
              (change)="onChange.emit($event)"
              [id]="controlName" />
          }
        }
      } @else {
        <p-inputMask
          [mask]="mask"
          [type]="type"
          [formControlName]="controlName"
          [class.is-valid]="!control?.invalid && control?.touched"
          [class.is-invalid]="control?.invalid && control?.touched"
          [required]="required"
          [placeholder]="placeholder | translate"
          [minlength]="minlength"
          [maxlength]="maxlength"
          [disabled]="true"
          [autocomplete]="autocomplete"
          (change)="onChange.emit($event)"
          [id]="controlName" />
      }

      <dk-field-validation-error-message [control]="control" />
    </div>
  </form>
} @else {
  <div id="dk-input" class="form-group text-right" [class.my-3]="has_my3" [class.mb-3]="has_mb3">
    <dk-label
      [label]="label"
      [labelDescription]="labelDescription"
      [isRequired]="required"
      [disabled]="disabled || control?.disabled" />
    <div class="input-group">
      @if (!mask) {
        @switch (type) {
          @case ('number') {
            <p-inputNumber
              mode="decimal"
              [useGrouping]="separateNumbers"
              [(ngModel)]="value"
              [required]="required"
              [placeholder]="placeholder | translate"
              [min]="min"
              [max]="max"
              [minFractionDigits]="minDecimalDigits"
              [maxFractionDigits]="maxDecimalDigits"
              [disabled]="disabled"
              [autocomplete]="autocomplete"
              (onChange)="onChange.emit($event)" />
          }
          @case ('password') {
            <p-password
              [(ngModel)]="value"
              [toggleMask]="true"
              [feedback]="false"
              [autocomplete]="autocomplete"
              (change)="onChange.emit($event)" />
          }
          @default {
            <input
              #input
              pInputText
              [type]="type"
              [(ngModel)]="value"
              [required]="required"
              [placeholder]="placeholder | translate"
              [minlength]="minlength"
              [maxlength]="maxlength"
              [disabled]="disabled"
              [autocomplete]="autocomplete"
              [pattern]="pattern"
              (change)="onChange.emit($event)" />
          }
        }
      } @else {
        <p-inputMask
          #input
          [mask]="mask"
          [type]="type"
          [(ngModel)]="value"
          [required]="required"
          [placeholder]="placeholder"
          [minlength]="minlength"
          [maxlength]="maxlength"
          [disabled]="true"
          [autocomplete]="autocomplete"
          (change)="onChange.emit($event)" />
      }
    </div>
  </div>
}
